import { terms } from 'lib/terms'

import { TermsLayout } from 'components/v2/TermsLayout/TermsLayout'

const TermsPatient = ({ content }) => {
	const metaTags = {
		title: 'Paciente Leia os Termos de Uso | Vittude',
		description:
			'Estes termos de uso vai apresentar quais são as condições, diretrizes, políticas e deveres que definem a relação entre você, paciente e a Vittude.'
	}

	return <TermsLayout content={content} metaTags={metaTags} />
}

export async function getStaticProps() {
	const content = await terms('termos-uso-paciente.md')

	return {
		props: {
			content
		}
	}
}

export default TermsPatient
